import {useState} from "react";
import Image from "../Gallery/components/Image/Image";
import Lightbox from "../Lightbox/Lightbox";
import './style.scss';

const getImageShape = image => {
    const width = Number(image.width);
    const height = Number(image.height);

    if (!width || !height) return 'horizontal';
    if (width >= height * 1.7) return 'horizontal';
    if (height >= width * 1.3) return 'vertical';
    return 'square';
};

const GridGallery = ({images = [], lightbox = false, title = null, className = ''}) => {
    const [showLightbox, setShowLightbox] = useState(false);
    const [lightboxData, setLightboxData] = useState({index: null, src: ''});

    if (images.length === 0) return null;

    const openLightbox = (index, src) => {
        setLightboxData({index, src});
        setShowLightbox(true);
    };

    const closeLightbox = () => setShowLightbox(false);

    return (
        <div className={`grid-gallery ${lightbox ? 'has-lightbox' : ''} ${className}`}>
            {lightbox && showLightbox && (
                <Lightbox
                    data={lightboxData}
                    gallery={images}
                    closeCB={closeLightbox}
                />
            )}

            {title && <h2 className="grid-gallery__title">{title}</h2>}

            <div className="grid-gallery__items">
                {images.map((image, index) => (
                    <div
                        className={`grid-gallery__item ${getImageShape(image)}`}
                        key={`${image.public_id}-${index}`}
                    >
                        <Image
                            src={image.public_id}
                            index={index}
                            onClick={lightbox ? openLightbox : undefined}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default GridGallery;